module.exports = __webpack_public_path__ + "static/2-3-482f3ce1253d1362169398b2f90d1d20.jpg";